import React from "react";

const BxlFacebookIcon: React.FC = () => (
    <svg
      width="11"
      height="18"
      viewBox="0 0 11 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.01198 18V9.8027H9.97364L10.4139 6.59319H7.01198V4.54887C7.01198 3.62272 7.28833 2.98862 8.71185 2.98862H10.5156V0.12717C9.63838 0.0391562 8.75577 -0.00285049 7.87317 0.000149987C5.25534 0.000149987 3.458 1.49239 3.458 4.23182V6.58719H0.515625V9.7967H3.46443V18H7.01198Z"
        fill="white"
      />
    </svg>
  );

export default BxlFacebookIcon;
